import React from "react";
import styled from "styled-components";
import {Field} from 'formik';

const  CheckboxFormik = ({ name, label,disabled }) => {

    return (
        <CheckBoxWrapper className={'checkbox-wrapper'}>
            <label className={'label-checkbox'}>
                <p>{label}</p>
                <Field
                    type="checkbox"
                    name={name}
                    disabled={disabled}
                />
                <span className="checkmark"/>
            </label>
        </CheckBoxWrapper>
    )
}

const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;

  label {
    font-weight: 500;
  }
  
label > input {
  opacity: 0;
  position: absolute;
  cursor: pointer;
}

.label-checkbox:after {
  content: "";
  position: absolute;
  display: none;
}

.label-checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 0.9em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: rgba(51, 148, 246, 0.2);
  }

  &:hover input ~ .checkmark {
    background-color: rgba(51, 148, 246, 1);
  }

  input:checked ~ .checkmark {
    background-color: rgba(51, 148, 246, 1);
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  input:checked ~ .checkmark:after {
    display: block;
  }

  .checkmark:after {
    left: 7px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  input:checked {
    background-color: rgba(73, 9, 170, 1);
  }
`

export default CheckboxFormik;